
const mca = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/mca.webp"
const coral_reef="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/coral_reef_alumni.webp"
const alumni_1982="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/alumni_1982.webp"
const silver_98="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/silver_98.webp"
const pre_gold_79="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/pre_gold_79.webp"
const diam_68="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/diam_68.webp"
const contrib_pic="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/clgphoto.webp"
const alumni1="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/alumni1.webp"
const alumni2="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/alumni2.webp"
const alumni3="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/alumni3.webp"

export const contributions=[
    {
        'id':'1',
        'heading':"One Week Training on Robotics",
        'sub-head':'Explanation....',
        'pic':contrib_pic,
        'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
                    'in leadership qualities so as to achieve better productivity and prosperity for our country.',
        'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
        "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
        "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
    },
    {
        'id':'2',
        'heading':'Heading2',
        'sub-head':'Explanation....',
        'pic':contrib_pic,
        'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
                    'in leadership qualities so as to achieve better productivity and prosperity for our country.',
        'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
        "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
        "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
    },
    {
        'id':'2',
        'heading':'Heading2',
        'sub-head':'Explanation....',
        'pic':contrib_pic,
        'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
                    'in leadership qualities so as to achieve better productivity and prosperity for our country.',
        'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
        "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
        "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
    },
]

export const slideshow_imgs=[
    alumni1,
    alumni2,
    alumni3
]

export const alumni_reunions=[
    {
        id:'1',
        coverpic:coral_reef,
        batch:"1984-88",
        name:"35th Coral Reef Batch Meet",
        desc:"1984-88 batch's 35th reunion in Kodaikanal on Aug 18-19 celebrated genuine connections and shared memories with 63 attendees.",
        date:"18th & 19th AUG 2023"
    },
    {
        id:'2',
        coverpic:alumni_1982,
        batch:"1978-82",
        name:"41st-Year Reunion Of Class 1982",
        desc:"The 1982 batch celebrated their 41st-year reunion at Kolli Hills on August 12-13, reliving college memories joyfully.",
        date:"12th & 13th AUG 2023"
    },
    {
        id:'3',
        coverpic:silver_98,
        batch:"1994-98",
        name:"Silver Jubilee Celebrations",
        desc:"Our heartfelt wishes to the Alumni of the 1994-98 Batch celebrating their Silver Jubilee on the ACCET Campus.!!",
        date:"16th JUL 2023"
    },
    {
        id:'4',
        coverpic:pre_gold_79,
        batch:"1974-79",
        name:"Pre-Golden Jubilee Meet",
        desc:"1974-79 ACCET alumni held a Pre-Golden Jubilee meet at Chennai, planning future events and skill development initiatives.",
        date:"29th & 30th MAR 2023"
    },
    {
        id:'5',
        coverpic:diam_68,
        batch:"1963-68",
        name:"Diamond Jubilee Celebration",
        desc:"The 1963 Freshmen held their Diamond Jubilee celebration on february 11, reliving college memories joyfully.",
        date:"11th FEB 2023"
    },
]
export const cardData = [
    {
        imageSrc:mca,
      title: ' Reunion of 1990-93 batch of MCA',
      
      videoSrc: 'https://drive.google.com/file/d/1vnlvSMtcF4JNZizii5MfpH1h4NcSgZWX/view?usp=sharing'
    },
   
    // Add more card data objects as needed
  ];